{
  "name": "webviewer-ui",
  "author": "Apryse Software Inc.",
  "version": "12.0.1",
  "description": "WebViewer UI built in React",
  "main": "src/index.js",
  "scripts": {
    "start": "npm run clean && node ./dev-server.js",
    "download-webviewer": "npx @pdftron/webviewer-downloader --core-only --path ./lib",
    "postinstall": "cp ./node_modules/@storybook/react-dom-shim/dist/react-16.js ./node_modules/@storybook/react-dom-shim/dist/react-18.js && patch-package",
    "lint": "eslint ./src --fix --ext .js,.jsx,.ts,.tsx",
    "lint:ci": "eslint ./src --quiet --ext .js,.jsx,.ts,.tsx && npm run icons:csp-check",
    "clean": "rimraf build",
    "bundle": "node ./esbuild-ui.js --production",
    "build": "npm run clean && npm run bundle",
    "translation": "node ./scripts/translate-i18n-files.js",
    "icons:csp-check": "node ../../scripts/normalize-icons-csp.js --check",
    "storybook": "storybook dev -p 6006 --ci",
    "build-storybook": "storybook build",
    "jest": "npx jest",
    "jest:watch": "jest --watch",
    "lint:styles": "stylelint '**/*.scss'"
  },
  "overrides": {
    "patch-package": {
      "tmp": "0.2.7"
    }
  },
  "dependencies": {
    "@emotion/cache": "^11.14.0",
    "@emotion/react": "^11.14.0",
    "@pdftron/canvas-to-pdf": "^1.1.1",
    "@pdftron/html2canvas": "^1.0.0",
    "autolinker": "^3.16.2",
    "classnames": "^2.5.1",
    "dayjs": "^1.8.19",
    "dompurify": "^3.4.9",
    "file-saver": "^2.0.5",
    "hotkeys-js": "^3.10.0",
    "i18next": "^19.9.2",
    "i18next-http-backend": "^4.0.0",
    "quill-mention": "^6.1.1",
    "react": "^17.0.0",
    "react-color": "^2.19.3",
    "react-dnd": "^14.0.2",
    "react-dnd-html5-backend": "^14.0.0",
    "react-dnd-touch-backend": "^16.0.0",
    "react-dom": "^17.0.0",
    "react-draggable": "^4.3.1",
    "react-error-boundary": "3.1.4",
    "react-i18next": "^11.3.1",
    "react-measure": "^2.3.0",
    "react-onclickoutside": "^6.9.0",
    "react-quill-new": "^3.4.6",
    "react-redux": "^7.1.3",
    "react-select": "^5.10.2",
    "react-shadow-dom-retarget-events": "1.1.0",
    "react-swipeable": "^5.5.1",
    "react-virtualized": "^9.21.2",
    "react-virtuoso": "^4.18.1",
    "redux": "^4.0.5",
    "redux-persist": "^6.0.0",
    "redux-thunk": "^2.3.0",
    "reselect": "^5.1.1",
    "uuid": "^14.0.0"
  },
  "devDependencies": {
    "@babel/cli": "^7.8.3",
    "@babel/core": "^7.8.3",
    "@babel/eslint-parser": "^7.16.0",
    "@babel/node": "^7.8.3",
    "@babel/plugin-proposal-class-properties": "^7.8.3",
    "@babel/plugin-proposal-export-namespace-from": "^7.8.3",
    "@babel/plugin-proposal-function-sent": "^7.8.3",
    "@babel/plugin-proposal-numeric-separator": "^7.8.3",
    "@babel/plugin-proposal-optional-chaining": "^7.8.3",
    "@babel/plugin-proposal-throw-expressions": "^7.8.3",
    "@babel/preset-env": "^7.8.3",
    "@babel/preset-react": "^7.8.3",
    "@babel/preset-typescript": "^7.28.5",
    "@chromatic-com/storybook": "^5.0.1",
    "@emotion/babel-plugin": "^11.13.5",
    "@google-cloud/translate": "^5.1.4",
    "@hot-loader/react-dom": "^17.0.2",
    "@pdftron/webviewer-downloader": "^1.4.4",
    "@pdftron/webviewer-reading-mode": "^1.1.0",
    "@reduxjs/toolkit": "^1.8.1",
    "@storybook/addon-a11y": "^10.2.13",
    "@storybook/addon-docs": "^10.2.13",
    "@storybook/addon-links": "^10.2.13",
    "@storybook/addon-themes": "^10.2.13",
    "@storybook/react-webpack5": "^10.2.13",
    "@testing-library/jest-dom": "^5.11.4",
    "@testing-library/react": "^10.4.9",
    "@testing-library/react-hooks": "^5.0.3",
    "@testing-library/user-event": "^12.7.3",
    "babel-jest": "^29.5",
    "babel-loader": "^8.0.6",
    "body-parser": "^1.19.0",
    "buffer": "^6.0.3",
    "clean-webpack-plugin": "^3.0.0",
    "copy-webpack-plugin": "^5.1.1",
    "core-js": "^3.6.4",
    "css-loader": "^3.4.2",
    "cssnano": "^4.1.11",
    "esbuild": "0.25.5",
    "esbuild-plugin-polyfill-node": "^0.3.0",
    "esbuild-sass-plugin": "^3.3.1",
    "eslint": "^8.57.0",
    "eslint-plugin-babel": "^5.3.0",
    "eslint-plugin-custom": "file:eslint-plugin-custom",
    "eslint-plugin-cypress": "^3.5.0",
    "eslint-plugin-import": "^2.30.0",
    "eslint-plugin-jsx-a11y": "^6.10.0",
    "eslint-plugin-no-unsanitized": "^4.1.0",
    "eslint-plugin-react": "^7.35.2",
    "eslint-plugin-react-hooks": "^4.6.2",
    "eslint-plugin-storybook": "10.2.13",
    "express": "^4.22.2",
    "file-loader": "^5.0.2",
    "identity-obj-proxy": "^3.0.0",
    "jest": "29.5",
    "jest-canvas-mock": "^2.5.1",
    "jest-environment-jsdom": "^29.5.0",
    "mini-css-extract-plugin": "0.8.0",
    "node-polyfill-webpack-plugin": "^3.0.0",
    "open": "^8.4.0",
    "patch-package": "^8.0.1",
    "postcss": "^8.4.38",
    "postcss-import": "^12.0.1",
    "postcss-loader": "^3.0.0",
    "postcss-preset-env": "^6.7.0",
    "process": "^0.11.10",
    "prop-types": "^15.7.2",
    "raw-loader": "^4.0.0",
    "react-hot-loader": "^4.13.1",
    "react-is": "^16.13.1",
    "redux-devtools-extension": "^2.13.8",
    "redux-logger": "^3.0.6",
    "regenerator-runtime": "^0.13.9",
    "rimraf": "^3.0.0",
    "sass": "^1.34.0",
    "sass-loader": "^7.1.0",
    "storybook": "^10.2.13",
    "storybook-addon-pseudo-states": "^10.2.13",
    "storybook-addon-rtl": "^3.0.0",
    "stream-browserify": "^3.0.0",
    "style-loader": "^1.1.3",
    "stylelint": "^13.13.1",
    "svg-inline-loader": "^0.8.0",
    "util": "^0.12.5",
    "webpack": "^5.91.0",
    "webpack-bundle-analyzer": "^3.6.0",
    "webpack-cli": "^5.1.4",
    "webpack-dev-middleware": "^7.2.1",
    "webpack-hot-middleware": "^2.26.1"
  },
  "lint-staged": {
    "./src/**/*.{js,ts}": "eslint --fix",
    "./src/**/*.scss": "npm run lint:styles"
  }
}
